export default __webpack_public_path__ + "static/media/ic_addstaff.eef18854.svg";